import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { GenPrivateKey } from "../../../routes/cryptography";

import FileDownload from "js-file-download";

class GenPrivKey extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      selectLevel: "128",
      statusGenPrivKey: "",
      errors: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleInputChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({ password: e.target.value });
    } catch (error) {
      //console.log(error);
    }
  }

  handleSelectChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({ selectLevel: e.target.value });
    } catch (error) {
      //console.log(error);
    }
  }

  handleSubmit(e) {
    try {
      e.preventDefault();
      //console.log(this.state.password);
      //console.log(this.state.selectLevel);
      GenPrivateKey(this.state.selectLevel, this.state.password).then(
        (result) => {
          try {
            //console.log(result);
            if (result.status === 200) {
              FileDownload(result.data.privKey, "privKey.pem");
              document.getElementById("view").style.borderColor = "green";
            } else {
              document.getElementById("view").style.borderColor = "red";

              this.setState({
                statusGenPrivKey: "Ошибка",
              });
            }
          } catch (error) {
            //console.log(error);
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        }
      );
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className="container" id="genprivkey">
        <h6 className="major">Генерация личного ключа</h6>
        <Form onSubmit={this.handleSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите пароль</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                type="password"
                placeholder="Пароль"
                minLength={8}
                required
                style={{ color: "white" }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Уровень стойкости ключа</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.selectLevel}
                as="select"
                custom
              >
                <option>128</option>
                <option>192</option>
                <option>256</option>
              </Form.Control>
            </Form.Group>

            <Form.Label style={{ float: "left" }}>
              {this.state.statusGenPrivKey}
            </Form.Label>
            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Сгенерировать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(GenPrivKey));
